export default __webpack_public_path__ + "static/media/intro.29cada60.svg";